import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';

export type ConfigurationVehicle = Pick<VehicleCycledEnergyRecord, 'configuration'>;

interface UseConfigurationsProperties {
  vehicles: ConfigurationVehicle[] | undefined;
}

const useConfigurations = ({ vehicles }: UseConfigurationsProperties): string[] => {
  return useMemo<string[]>(() => {
    if (!vehicles) return [];

    const unique = new Set<string>();

    for (const vehicle of vehicles) {
      unique.add(vehicle.configuration);
    }

    return [...unique].toSorted((a, b) => a.localeCompare(b));
  }, [vehicles]);
};

export default useConfigurations;
